<template>
  <span>
    <dots-menu
      v-if="splitMergePolygonsEnabled"
      :items="dotsItems"
      close-on-content-click
      @splitLine="$emit('splitLine')"
      @splitLineHalf="$emit('splitLineHalf')"
    >
      <template #activator="{ on }">
        <span v-on="getListeners(on)">
          <table-button name="button-edit-split-line-menu" v-bind="{ ...$props, ...$attrs }" />
        </span>
      </template>
    </dots-menu>
    <table-button v-else name="button-edit-split-line" v-bind="{ ...$props, ...$attrs }" @click="$emit('splitLine')" />
  </span>
</template>
<script>
import { get, sync } from 'vuex-pathify';
import DotsMenu from '@/components/DotsMenu';
import TableButton from '@/components/TableButton';
export default {
  name: 'TableButtonsEditSplitLine',
  components: { DotsMenu, TableButton },
  computed: {
    isSplittingLineButtonActive: sync('edit/isSplittingLineButtonActive'),
    advancedDigitizingPermissions: get('users/toolsPermissions@ADVANCED_DIGITIZING.main_value'),
    isAdvancedDigitizingEnabled: get('admin/additionalModules@ADVANCED_DIGITIZING.enabled'),
    isSplitLineHalfEnabled: get('admin/settingsValues@split_line_half_enabled'),
    splitMergePolygonsEnabled() {
      return this.isAdvancedDigitizingEnabled && this.isSplitLineHalfEnabled && this.advancedDigitizingPermissions > 0;
    },
    dotsItems() {
      return [{ name: 'splitLine' }, { name: 'splitLineHalf' }];
    },
  },
  methods: {
    getListeners(on) {
      return this.isSplittingLineButtonActive
        ? {
            click: () => {
              this.$emit('splitLine');
            },
          }
        : on;
    },
  },
};
</script>
